'use client'

import { useRouter } from 'next/router'
import React, { ComponentPropsWithRef, useCallback } from 'react'
import styled from 'styled-components'

import { focusOutline } from '@syconium/little-miss-figgy/dist/utility-classes'

const StyledLink = styled.a`
  ${focusOutline};
`

type LinkWithFallbackProps = {
  href: string
  fallbackHref: string
} & ComponentPropsWithRef<typeof StyledLink>

const LinkWithFallback = ({
  href,
  fallbackHref,
  children,
  ...htmlAttributes
}: LinkWithFallbackProps) => {
  const { prefetch, push } = useRouter()

  const handleOnClick = useCallback(async () => {
    // TODO: Add some kind of subtle loading indicator to prevent INP issues.

    const isValidHrefPromise = fetch(href, { method: 'HEAD' })
    const hrefPrefetchPromise = prefetch(href)
    const fallbackHrefPrefetchPromise = prefetch(fallbackHref)

    const isValidHref = (await isValidHrefPromise).ok

    if (isValidHref) {
      await hrefPrefetchPromise
      push(href)
    } else {
      await fallbackHrefPrefetchPromise
      push(fallbackHref)
    }
  }, [fallbackHref, href, prefetch, push])

  return (
    <StyledLink
      {...htmlAttributes}
      onClick={e => {
        e.preventDefault()
        handleOnClick()
      }}
      href={fallbackHref}
    >
      {children}
    </StyledLink>
  )
}

export default LinkWithFallback
